// @flow
export default class MultiSelectFilter {
  selected: Array<string>

  excludeSelectedItems: boolean

  constructor(selected: Array<string> = [], excludeSelectedItems: boolean = true) {
    this.selected = selected
    this.excludeSelectedItems = excludeSelectedItems
  }

  isSet = (): boolean => Boolean(this.selected.length || !this.excludeSelectedItems)
}
